import orderService from "../../services/orderService";
import Vue from 'vue'
import { distinctById } from "../../utils";
import axios from 'axios'

var order_request;

const state = {
    orders: [],
    loading_orders: false,
    next_page: undefined,

    selected_orders: [],
    move_mode: false,
    global_state: 'W',
};

const actions = {
    fastClear({commit}) {
        commit('clearData')
    },
    getOrders({commit, state}, params) {

        if (order_request) {
            order_request.cancel();
        }
        const CancelToken = axios.CancelToken;
        order_request = CancelToken.source();

        if (state.next_page === null) {
            return
        }

        state.loading_orders = state.next_page === undefined;
        params.cursor = state.next_page;
        return new Promise((resolve, reject) => {
            orderService.fetchOrders({params, token: order_request.token})
                .then(data => {
                    let orders = distinctById(state.orders.concat(data.results));
                    commit('setOrders', {next: data.next, orders});
                    state.loading_orders = false;
                    resolve()
                })
                .catch((error) => {
                    if (error.__CANCEL__) {
                        return
                    }
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о заказах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    state.loading_orders = false;

                    reject()
                });
        })
    },
    getOrder({commit}, order_id) {
        return new Promise((resolve, reject) => {
            orderService.getOrder(order_id)
                .then(order => {
                    commit('addOrder', order);
                    resolve()
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о заказе.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        });
    },
    getSharedOrders({commit, state}, params) {

        if (state.next_page === null) {
            return
        }

        state.loading_orders = state.next_page === undefined;
        params.cursor = state.next_page;
        orderService.fetchSharedOrders(params)
            .then(data => {
                let orders = distinctById(state.orders.concat(data.results));
                commit('setOrders', {next: data.next, orders});
                state.loading_orders = false;
            })
            .catch((error) => {
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о заказах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });
                state.loading_orders = false;
            });
    },
    getFilteredOrders({commit, state}, params) {

        if (order_request) {
            order_request.cancel();
        }
        const CancelToken = axios.CancelToken;
        order_request = CancelToken.source();

        if (state.next_page === null) {
            return
        }

        state.loading_orders = state.next_page === undefined;
        params.cursor = state.next_page;

        if (['hide_order'].includes(params.view)) {
            commit('setOrders', {next: null, orders: []});
            state.loading_orders = false;
            order_request = null
            return;
        }

        orderService.fetchFilteredOrders({params, token: order_request.token})
            .then(data => {
                let orders = distinctById(state.orders.concat(data.results));
                commit('setOrders', {next: data.next, orders});
                state.loading_orders = false;
                order_request = null
            })
            .catch((error) => {
                if (error.__CANCEL__) {
                    return
                }
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о заказах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });
                state.loading_orders = false;
            });
    },
    addOrder({commit}, order) {
        return new Promise((resolve, reject) => {
            let index = order.index;
            let fd = new FormData();
            fd.append('request_id', new Date().getTime().toString())
            for (let key in order) {
                if (order[key] === null) {
                    continue;
                }
                fd.append(key, order[key]);
            }
            orderService.postOrder(fd)
                .then(order => {
                    resolve();
                    commit('setOrder', {index, order});
                })
                .catch((error) => {
                    reject();
                    let description = error.response ? error.response.data.detail || "Без описания." : error
                    if (error.response && error.response.status === 400) {
                        description = '<br>'
                        for (const [key, value] of Object.entries(error.response.data)) {
                            description += `"${key}" - ${value}<br>`
                        }
                    }
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить заказ.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${description}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    editOrder({commit}, order) {
        return new Promise((resolve, reject) => {
            orderService.editOrder(order)
                .then(order => {
                    resolve();
                    commit('addOrder', order);
                })
                .catch((error) => {
                    reject();
                    let description = error.response ? error.response.data.detail || "Без описания." : error
                    if (error.response && error.response.status === 400) {
                        description = '<br>'
                        for (const [key, value] of Object.entries(error.response.data)) {
                            description += `"${key}" - ${value}<br>`
                        }
                    }
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить заказ.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${description}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    deleteOrder({commit}, order) {
        return new Promise((resolve, reject) => {
            orderService.deleteOrder(order.id)
                .then(() => {
                    resolve();
                    commit('deleteOrder', order);
                })
                .catch((error) => {
                    reject();
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось удалить заказ.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    togglePaid({commit}, {check, order_id}) {
        let fd = new FormData();
        fd.append('check', check);
        return new Promise((resolve, reject) => {
            orderService.togglePaid({'data': fd, order_id})
                .then((order) => {
                    commit('addOrder', order);
                    resolve(order)
                })
                .catch((error) => {
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось отметить оплаченым заказ.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    toggleService({commit}, {service_id, action_place, order_id}) {
        return new Promise((resolve, reject) => {
            orderService.toggleService({service_id, action_place, order_id})
                .then((order) => {
                    commit('addOrder', order);
                    resolve(order)
                })
                .catch((error) => {
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось совершить действие с услугой.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    toggleReturnValue({commit}, {value, action_place, order_id}) {
        return new Promise((resolve, reject) => {
            orderService.toggleReturnValue({value, action_place, order_id})
                .then((order) => {
                    commit('addOrder', order);
                    resolve(order)
                })
                .catch((error) => {
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось совершить действие по возврату средств клиенту.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    toggleCollected({commit}, data) {
        return new Promise((resolve, reject) => {
            orderService.toggleCollected(data)
                .then((order) => {
                    commit('addOrder', order);
                    resolve(order)
                })
                .catch((error) => {
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось отметить собраным заказ.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    setState({commit}, data) {
        return new Promise((resolve, reject) => {
            orderService.setState(data)
                .then((order) => {
                    resolve();
                    commit('addOrder', order);
                })
                .catch((error) => {
                    reject();
                    if (error.response) Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сменить статус заказа.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        })
    },
    moveOrders({commit, state}, {album_id, old_album_id}) {
        return new Promise((resolve, reject) => {
            orderService.moveOrders({orders: state.selected_orders, album: album_id, old_album: old_album_id})
                .then(() => {
                    resolve();
                    commit('deleteOrders', state.selected_orders)
                    commit('moveComplete')
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось переместить заказы.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    }
};

const mutations = {
    allSetSelected(state) {
        let order = undefined
        for (let i in state.orders.filter(obj => obj.state !== 'P' && obj.state !== 'O' && obj.state !== 'F')) {
            order = state.orders[i];
            if (!state.selected_orders.includes(order.id)) {
                state.selected_orders.push(order.id);
                if (order.replacements) {
                    for (let i in order.replacements) {
                        state.selected_orders.push(order.replacements[i].id);
                    }
                }
            }
        }
    },
    clearSelected(state) {
        state.selected_orders = []
    },
    addToSelected(state, order) {
        if (!state.selected_orders.includes(order.id)) {
            state.selected_orders.push(order.id);
            if (order.replacements) {
                for (let i in order.replacements) {
                    state.selected_orders.push(order.replacements[i].id);
                }
            }
        }
    },
    removeFromSelected(state, order) {
        let index = state.selected_orders.findIndex(obj => obj === order.id);
        state.selected_orders.splice(index, 1);
        if (order.replacements) {
            for (let i in order.replacements) {
                let replacement = order.replacements[i];
                let index = state.selected_orders.findIndex(obj => obj === replacement.id);
                state.selected_orders.splice(index, 1);
            }
        }
    },
    setOrders(state, {next, orders}) {
        state.next_page = next;
        state.orders = orders;
    },
    setOrder(state, {index, order}) {
        let main_order = undefined;
        if (order.main_order !== null && order.main_order >= 0) {
            main_order = state.orders.find(item => item.id === order.main_order)
        }
        if (main_order !== undefined) {
            if (main_order.replacements[index] !== undefined && (main_order.replacements[index].id === null || main_order.replacements[index].id === order.id)) {
                Vue.set(main_order.replacements, index, order)
            } else {
                main_order.replacements.push(order);
            }
        } else {
            // find index не было, добавил после того как сделал чтоб возвращался основной заказ всегда
            const find_index = state.orders.findIndex(obj => obj.id === order.id);
            if (find_index !== -1) {
                index = find_index;
            }
            if (state.orders[index] !== undefined && (state.orders[index].id === null || state.orders[index].id === order.id)) {
                // if (state.orders[index] !== undefined && state.orders[index].id === order.id) {
                Vue.set(state.orders, index, order);
            } else {
                state.orders.unshift(order);
            }
        }
    },
    addOrder(state, order) {
        const index = state.orders.findIndex(item => item.id === order.id)
        if (order.main_order !== null) {
            if (index !== -1) {
                Vue.set(state.orders, index, order);
            }
            let main_order = state.orders.find(item => item.id === order.main_order);
            if (main_order.replacements) {
                const replace_index = main_order.replacements.findIndex(item => item.id === order.id);
                if (replace_index !== -1) {
                    Vue.set(main_order.replacements, replace_index, order);
                } else {
                    main_order.replacements.push(order);
                }
            } else {
                Vue.set(main_order, 'replacements', [order])
            }
        } else {
            if (index !== -1) {
                Vue.set(state.orders, index, order);
            } else {
                state.orders.unshift(order);
            }
        }
    },
    updateOrder(state, order) {
        const index = state.orders.findIndex(item => item.id === order.id);
        if (index !== -1) {
            Vue.set(state.orders, index, order);
        }
    },
    deleteOrder(state, order) {
        if (order.main_order) {
            let main_order = state.orders.find(item => item.id === order.main_order);
            Vue.set(main_order, 'replacements', main_order.replacements.filter(item => item.id !== order.id))
        } else {
            state.orders = state.orders.filter(item => item.id !== order.id);
        }
    },
    deleteOrders(state, orders) {
        state.orders = state.orders.filter(obj => !orders.includes(obj.id));
    },
    moveComplete(state) {
        state.selected_orders = [];
        state.move_mode = false;
    },
    clearData(state) {
        state.move_mode = false;
        state.selected_orders = [];
        state.next_page = undefined;
        state.orders = [];
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}